import React from 'react';
import { motion } from 'framer-motion';
import { Helmet } from 'react-helmet-async';
import Hero from '../components/home/Hero';
import QuickActions from '../components/home/QuickActions';
import NewsSection from '../components/home/NewsSection';
import InfoSection from '../components/home/InfoSection';

const RevealSection = ({ children }) => (
  <motion.div
    initial={{ opacity: 0, y: 30 }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-100px" }}
    transition={{ duration: 0.8, ease: "easeOut" }}
  >
    {children}
  </motion.div>
);

export default function Home() {
  return (
    <main className="overflow-hidden relative">
      <Helmet>
        <title>Hellerup Lægehus | Din praktiserende læge i Hellerup</title>
        <meta name="description" content="Søg lægehjælp hos Hellerup Lægehus. Vi tilbyder høj faglighed, omsorg og tid samme dag. Opret dig eller brug selvbetjening via MinLæge appen her." />
        <meta property="og:title" content="Hellerup Lægehus | Din praktiserende læge i Hellerup" />
        <meta property="og:description" content="Søg lægehjælp hos Hellerup Lægehus. Vi tilbyder høj faglighed, omsorg og tid samme dag. Opret dig eller brug selvbetjening via MinLæge appen her." />
        <meta property="og:image" content="https://assets.auxodev.dk/assets/3d56beb5-25cd-44c2-a35b-95780bd285dd/cb42cb30-a658-4930-847f-8c3554cf0280.png" />
        <html lang="da-DK" />
      </Helmet>
      
      <Hero />
      <div className="space-y-0">
        <RevealSection>
          <QuickActions />
        </RevealSection>
        <RevealSection>
          <NewsSection />
        </RevealSection>
        <RevealSection>
          <InfoSection />
        </RevealSection>
      </div>
    </main>
  );
}
